app.controller("CreateGroupWindowController", ["$scope", "params", "$uibModalInstance", "StaticData", "QuestionnairesService", "toastr",
    function ($scope, params, $uibModalInstance, StaticData, QuestionnairesService, toastr) {
        $scope.title = ''
        $scope.mode = "create";

        $scope.submit = function () {
            if (!$scope.title) toastr.error('გთხოვთ მიუთითოთ ჯგუფის სახელწოდება');
            $uibModalInstance.close({ title: $scope.title, questions: [] });
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);
